import {
  formatApplovinEventData,
  formatApplovinUserData,
} from '@openeducation/pp-js-utils';
import type {
  ApplovinBeginCheckoutEvent,
  ApplovinPurchaseEvent,
  GTMEventData,
  InvoiceCardProps,
} from '@openeducation/pp-rn-shared-types';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export type ApplovinEventParams = {
  // When the checkout comes from an AppLovin click, the same dedupe_id goes to
  // the Conversion API (through AG).
  dedupeId: string;
  email?: string;
  // See getApplovinUserId.
  userId?: string;
};

export function useGoogleTagManager() {
  const pushEvent = (eventData: GTMEventData) => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
    }
  };

  const pushEventCheckoutStarted = (
    leadServiceId: string | undefined,
    invoiceCardProps: InvoiceCardProps,
    { dedupeId, email, userId }: ApplovinEventParams
  ) => {
    const applovinAxonBeginCheckout: ApplovinBeginCheckoutEvent = {
      ...formatApplovinEventData(invoiceCardProps),
      user_data: formatApplovinUserData(email, userId),
    };
    pushEvent({
      event: 'begin_checkout',
      leadServiceId,
      applovinAxonBeginCheckout,
      applovinAxonDedupeId: dedupeId,
    });
  };

  // For purchase, the dedupe_id is also the transaction_id.
  const pushEventPurchase = (
    leadServiceId: string | undefined,
    invoiceCardProps: InvoiceCardProps,
    { dedupeId, email, userId }: ApplovinEventParams
  ) => {
    const applovinAxonPurchase: ApplovinPurchaseEvent = {
      ...formatApplovinEventData(invoiceCardProps),
      transaction_id: dedupeId,
      shipping: 0,
      user_data: formatApplovinUserData(email, userId),
    };
    pushEvent({
      event: 'purchase',
      leadServiceId,
      applovinAxonPurchase,
      applovinAxonDedupeId: dedupeId,
    });
  };

  return {
    pushEvent,
    pushEventCheckoutStarted,
    pushEventPurchase,
  };
}
